// extracted by mini-css-extract-plugin
module.exports = {"swatygt":"swatygt"};